// extracted by mini-css-extract-plugin
module.exports = {"Thumbnails":"ImageGallery_Thumbnails__nio4S","ImageGalleryWithPagination":"ImageGallery_ImageGalleryWithPagination__OdTfW"};